import { render } from "./TodayView.vue?vue&type=template&id=9bef770e"
import script from "./TodayView.vue?vue&type=script&lang=js"
export * from "./TodayView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__